// The header line and foot for pages shown before login.
import type { ReactNode } from 'react';
import { sv } from '@aldorock-fordon/shared/sv';
import { Wordmark } from './Wordmark.tsx';

export function PublicShell({ children }: { children: ReactNode }) {
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main">
        {sv.app.skipLink}
      </a>
      <header className="band">
        <div className="band-inner">
          <Wordmark />
          <span className="band-sep" aria-hidden="true" />
          <span className="band-title">{sv.app.product}</span>
        </div>
      </header>
      <main id="main" className="app-main app-body" tabIndex={-1}>
        {children}
      </main>
      <footer className="app-foot">
        <p>{sv.app.supplier}</p>
      </footer>
    </div>
  );
}
